import React, { useState, useContext, useEffect, useRef } from 'react';
import { Row, Col, Nav, NavItem } from 'reactstrap';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { DepartmentContext } from '../../../../DepartmentWrapper';
import SettingsPopover from '../../Header/SettingsPopover/SettingsPopover';
import Focuses from './Focuses/Focuses';
import Tags from './Tags/Tags';
import Advanced from './Advanced/Advanced';
import Notifications from './Notifications/Notifications';
import { RouterPrompt } from '../../Common/RouterPrompt/RouterPrompt';
import { clone } from '../../../../Services/schedule';
import AdminCommunicationSettings from '../AdminCommunications/AdminCommunicationSettings/AdminCommunicationSettings';
import AdminEvluationSettingsLanding from '../AdminEvaluationSettings/AdminEvaluationSettingsLanding';
import CandidateSettings from './CandidateSettings/CandidateSettings';
import DirectApplication from 'Body/RezRATE/Body/DirectApplication/Directapplication';
import DirectApplicationSettings from './DirectApplication/DirectApplicationSettings';
import PdfTemplateDesigner from './PdfTemplateDesigner/PdfTemplateDesigner';

function AdminSettings({ activeDepartment, candidates, getActiveCandidates }) {
  const [currentTab, setCurrentTab] = useState(1);
  const [tabToGo, setTabToGo] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const candidateRequestKeyRef = useRef(null);

  const [pageChanges, setPageChanges] = useState({
    sendMessage: false,
    history: false,
    settings: false,
    manageWaitlist: false,
    pdfTemplate: false,
  });

  const dContext = useContext(DepartmentContext);
  const { department, season } = dContext || {};
  const { ApplicationSystem } = department || {};

  const { path } = useRouteMatch();

  const history = useHistory();
  const { location } = history;
  const { pathname } = location;

  let hasChanges = false;

  Object.values(pageChanges).forEach((value) => {
    if (value) {
      hasChanges = true;
    }
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (pathname) {
      settingTabs.forEach((tab) => {
        if (pathname.indexOf(tab.path) >= 0) {
          if (currentTab != tab.tab) {
            setCurrentTab(tab.tab);
            setTabToGo(tab.tab);
          }
        }
      });
    }
  }, [pathname]);

  useEffect(() => {
    const candidateRequestKey = `${department?.pk_Department}-${season?.pk_Season}`;

    if (
      currentTab !== 7 ||
      candidates.length > 0 ||
      !department?.pk_Department ||
      !season?.pk_Season ||
      candidateRequestKeyRef.current === candidateRequestKey
    ) {
      return;
    }

    candidateRequestKeyRef.current = candidateRequestKey;
    getActiveCandidates(season.pk_Season, department.pk_Department);
  }, [candidates.length, currentTab, department?.pk_Department, getActiveCandidates, season?.pk_Season]);

  const updateChanges = (key, value) => {
    const newChanges = clone(pageChanges);
    newChanges[key] = value;
    setPageChanges(newChanges);
  };

  const renderTabContent = () => {
    return settingTabs.map((tab, index) => {
      if (currentTab == tab.tab) return tab.component;
    });
  };

  const settingTabs = [
    {
      label: 'Program Settings',
      path: '/programs',
      tab: 1,
      component: <SettingsPopover dContext={dContext} updateChanges={updateChanges} windowWidth={windowWidth} />,
    },
    {
      label: 'Candidate Settings',
      path: '/candidateSettings',
      tab: 2,
      component: <CandidateSettings updateChanges={updateChanges} windowWidth={windowWidth} />,
    },

    {
      label: 'Notifications',
      path: '/notifications',
      tab: 3,
      component: <Notifications dContext={dContext} updateChanges={updateChanges} windowWidth={windowWidth} />,
    },
    {
      label: 'Communication',
      path: '/communication',
      tab: 4,
      component: (
        <AdminCommunicationSettings dContext={dContext} updateChanges={updateChanges} windowWidth={windowWidth} />
      ),
    },
    {
      label: 'Evaluation',
      path: '/evaluation',
      tab: 5,
      component: (
        <AdminEvluationSettingsLanding
          dContext={dContext}
          updateChanges={updateChanges}
          setPageChanges={setPageChanges}
          pageChanges={pageChanges}
          windowWidth={windowWidth}
        />
      ),
    },
    {
      label: 'Direct Application',
      path: '/directApplication',
      tab: 6,
      component: <DirectApplicationSettings windowWidth={windowWidth} />,
    },
    {
      label: 'Print Materials Templates',
      path: '/printMaterialsTemplates',
      tab: 7,
      component: <PdfTemplateDesigner candidates={candidates} updateChanges={updateChanges} />,
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Nav className="nav-tabs">
            {settingTabs.map((tab, index) => {
              if (tab.label === 'Direct Application' && ApplicationSystem !== 'direct_application') {
                return null;
              }
              return (
                <NavItem className="nav-item" key={index}>
                  <Link
                    className={'nav-link ' + (currentTab === tab.tab ? 'active' : '')}
                    to={`${path}${tab.path}`}
                    onClick={() => {
                      if (!hasChanges) {
                        setCurrentTab(tab.tab);
                      }
                      setTabToGo(tab.tab);
                    }}
                  >
                    <i className="fa fa-paper-plane"></i> {tab.label}
                  </Link>
                </NavItem>
              );
            })}
          </Nav>
        </div>
      </div>

      {renderTabContent()}

      <RouterPrompt
        hasChanges={hasChanges || currentTab != tabToGo}
        okLabel={'Discard Changes'}
        onCancel={() => {
          setTabToGo(currentTab);
        }}
        onOk={() => {
          setCurrentTab(tabToGo);
          setPageChanges({
            advancedSettings: false,
            programSettings: false,
            notificationSettings: false,
            pdfTemplate: false,
          });

          return true;
        }}
      />
    </div>
  );
}

export default AdminSettings;
